import { defineStyleConfig } from '@chakra-ui/system';

export const Card = defineStyleConfig({
    baseStyle: {
        container: {
            boxShadow: '0px 2px 10px 0px rgba(65, 64, 66, 0.14)',
        },
        body: {
            padding: 0,
        },
    },
});
